import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { memberPortalRoutes } from "../constants";

function normalizePath(path) {
  return path.replace(/\/+$/, "");
}

function useIsRouteMatch(targetPath) {
  const location = useLocation();

  const isMatch = useMemo(() => {
    return normalizePath(location.pathname) === normalizePath(targetPath);
  }, [location.pathname, targetPath]);

  return isMatch;
}

function useIsHomePage() {
  return useIsRouteMatch(memberPortalRoutes.home);
}

function useIsNotesPage() {
  return useIsRouteMatch(memberPortalRoutes.notes);
}

function useIsGivePage() {
  return useIsRouteMatch(memberPortalRoutes.give);
}

function useIsMemberPortalRoute() {
  const isHomePage = useIsHomePage();
  const isNotesPage = useIsNotesPage();
  const isGivePage = useIsGivePage();

  return isHomePage || isNotesPage || isGivePage;
}

export { useIsHomePage, useIsNotesPage, useIsGivePage, useIsMemberPortalRoute };
